/**
 * Real-time inventory event types and payloads
 * Used for WebSocket communication between API and clients
 */
export var InventoryEventType;
(function (InventoryEventType) {
    InventoryEventType["CREATED"] = "inventory:created";
    InventoryEventType["UPDATED"] = "inventory:updated";
    InventoryEventType["SOLDOUT"] = "inventory:soldout";
    InventoryEventType["EXPIRED"] = "inventory:expired";
})(InventoryEventType || (InventoryEventType = {}));
//# sourceMappingURL=inventory-events.js.map